import type { Macro, SaveMacroRequestBody } from "@/common/types/macros";
import { referenceClient } from "@/lib/orpc/client";

export const getMacros = async (expectedUserUid?: string): Promise<Macro[]> => {
  const { items } = await referenceClient.macros(
    {},
    { context: { expectedUserUid } },
  );
  return items.map((macro) => ({
    public_id: macro.public_id,
    name: macro.name ?? "",
    section: macro.section ?? "",
    details: macro.details ?? "",
  }));
};

export const saveMacro = async (
  body: SaveMacroRequestBody,
  expectedUserUid?: string,
): Promise<{ public_id: string }> => {
  const { macroPublicId, name, section, details } = body;
  const input = { name, section, details };
  const options = { context: { expectedUserUid } };
  return macroPublicId === ""
    ? referenceClient.createMacro({ body: input }, options)
    : referenceClient.updateMacro(
        { params: { public_id: macroPublicId }, body: input },
        options,
      );
};

export const deleteMacro = async (
  macroPublicId: string,
  expectedUserUid?: string,
): Promise<{ public_id: string }> =>
  referenceClient.deleteMacro(
    { params: { public_id: macroPublicId } },
    { context: { expectedUserUid } },
  );
